import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { paths } from "../../config/router.config";
import wsclients from "../../services/wsclients";
import NewSupportRequestView from "./NewSupportRequestView";
import CustomLoading from '../../components/CustomLoading';
import CustomAlert from '../../components/CustomAlert';
import { useTranslation } from "react-i18next";

export default function NewSupportRequestController(props){
    console.log("props ====", props);
    const history = useHistory();
    const {t} = useTranslation();
    
    const [request_info, setRequestInfo] = useState({});
    const [queues, setQueues] = useState([]);
    const [showLoading, onShowLoading] = useState([]);
    const [error, setError] = useState({});

    const [types, setTypes] = useState([
        { id: '1',  name: 'Complaint' },
        { id: '2',  name: 'Account and Billing' },
        { id: '3',  name: 'Hardware' },
        { id: '4',  name: 'Connectivity' },
    ]);
    const [typeSelected, setTypeSelected] = useState(null);

    useEffect(() => {
        getQueues();
    },[]);

    const getQueues = async() =>{
        onShowLoading(true);
        let result = await wsclients.config.getQueues();
        if (result.code === 'OK' && result.data && result.data.content){
            let queues = [...result.data.content]
            queues.forEach(element => {
                element.label = element.name
                element.value = element.id
            });
            setQueues(queues);
        }
          
        onShowLoading(false);
     }

    const onSaveRequest = async(values) => {
        console.log("values==", values);
        const { queue_id, description } = values;
        if(!queue_id){
            showAlert(true, t('please_chosse_classification'));
            return;
        }
        let new_request_info = {};
        new_request_info.description = description;
        new_request_info.queue_id = queue_id;

        onShowLoading(true);
        try{
            let result = await wsclients.config.createServiceRequest(new_request_info);
            if (result.code==='OK'){
                showAlert(true, t('create_service_request_success'));
                history.push(paths.support);
            }
            else{
                showAlert(true, t('create_service_request_failed'));
            }
        }
        catch(e){
            showAlert(true, t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const onCancel = () => {
        history.push(paths.support);
    }

    const showAlert = (status, message, callback) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            callback: callback
        });
    }
    
    const onCloseAlert = () => {
        onShowLoading(false);
        if(error.callback){
            error.callback();
        }
        setError({
            showAlert: false,
            message: '',
            status: '',
            callback: null
        })
    }
    return(
        <>
            <NewSupportRequestView 
                queues={queues}
                typeSelected={typeSelected}
                onSaveRequest={onSaveRequest}
                onCancel={onCancel}
            />
            {error.showAlert &&<CustomAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
                showButtonClose={true}
            />}
            {showLoading && <CustomLoading open={showLoading}/>}
        </>
    );
}